module.exports = __webpack_public_path__ + "static/img/banner.640fddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_80y/images/banner.png
// module id = mm6f
// module chunks = 36